import { render, staticRenderFns } from "./company-show.vue?vue&type=template&id=3070c85c"
import script from "./company-show.vue?vue&type=script&lang=js"
export * from "./company-show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports